import ApiError from '../shared/api/ApiError';
import { http } from '../shared/api';
import { getFileNameFromContentDisposition } from '../shared/utils/download';

const EXPORT_POLL_INTERVAL_MS = 1500;
const EXPORT_POLL_MAX_ATTEMPTS = 200;

export const getReportSummary = (fiscalYear, config = {}) => http.get(
  '/api/reports/summary',
  {
    ...config,
    params: fiscalYear == null ? undefined : { fiscal_year: Number(fiscalYear) },
  },
);

const fallbackFileName = (fiscalYear, mode) => (
  `GHG_${Number(fiscalYear)}_Report${mode === 'full' ? '_Full' : ''}.xlsx`
);

const headerWarnings = value => String(value || '')
  .split(',')
  .map(item => item.trim())
  .filter(Boolean);

const sleep = ms => new Promise(resolve => setTimeout(resolve, ms));

export const enqueueReportExport = (fiscalYear, mode) => http.post(
  `/api/reports/${Number(fiscalYear)}/export`,
  null,
  { params: { mode } },
);

export const getReportExportStatus = operationId => http.get(
  `/api/reports/export/${encodeURIComponent(operationId)}`,
);

async function downloadReportExport(operationId) {
  const response = await http.downloadResponse(
    `/api/reports/export/${encodeURIComponent(operationId)}/download`,
  );
  return response;
}

export async function downloadReport(fiscalYear, mode) {
  const enqueued = await enqueueReportExport(fiscalYear, mode);
  let status = enqueued;
  for (let attempt = 0; attempt < EXPORT_POLL_MAX_ATTEMPTS; attempt += 1) {
    if (status.status === 'SUCCESS') {
      const response = await downloadReportExport(enqueued.operation_id);
      return {
        blob: response.data,
        fileName: getFileNameFromContentDisposition(
          response.headers?.['content-disposition'],
          fallbackFileName(fiscalYear, mode),
        ),
        warnings: headerWarnings(response.headers?.['x-report-warnings']),
      };
    }
    if (status.status === 'FAILED') {
      const summary = status.error_summary || {};
      throw new ApiError(summary.message || 'REPORT_EXPORT_FAILED', {
        status: 500,
        kind: 'server',
        params: summary.params || {},
      });
    }
    await sleep(EXPORT_POLL_INTERVAL_MS);
    status = await getReportExportStatus(enqueued.operation_id);
  }
  throw new ApiError('REPORT_EXPORT_TIMEOUT', { status: 500, kind: 'server' });
}